import { Dispatch, PropsWithChildren, SetStateAction, useMemo } from 'react';
import { createSafeContext } from '@mews/framework';
import { getConflicts } from '../components/form/steps/itemsAndConditions/conflicts/getConflicts';

interface RoutingRuleConflictsContextValue {
    handleClose: React.DispatchWithoutAction;
    isActive: boolean;
    conflicts: ReturnType<typeof getConflicts>;
    setConflicts: Dispatch<SetStateAction<ReturnType<typeof getConflicts>>>;
    routingRuleId?: string;
}

export const { RoutingRuleConflictsContextProvider: ContextProvider, useRoutingRuleConflictsContext } =
    createSafeContext<'RoutingRuleConflictsContext', RoutingRuleConflictsContextValue>('RoutingRuleConflictsContext');

export const RoutingRuleConflictsContextProvider = ({
    children,
    handleClose,
    isActive,
    conflicts,
    setConflicts,
    routingRuleId,
}: PropsWithChildren<RoutingRuleConflictsContextValue>) => {
    const contextValue = useMemo(
        () => ({
            handleClose,
            isActive,
            conflicts,
            setConflicts,
            routingRuleId,
        }),
        [handleClose, isActive, conflicts, setConflicts, routingRuleId]
    );

    return <ContextProvider value={contextValue}>{children}</ContextProvider>;
};
